var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayLine = function SvgPlayLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.455 12 10.7 8.165v7.673l5.755-3.836Zm2.683.375L9.6 18.735a.45.45 0 0 1-.699-.375V5.641a.45.45 0 0 1 .7-.374l9.538 6.36a.448.448 0 0 1 0 .748Z"
  })));
};
export default SvgPlayLine;